module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/spec-offer-043c1f3a11dbcd14b4344bb522a5ff8d.webp";